import NumericFormatterFactory from './numeric-formatter';

export default NumericFormatterFactory;
